import { render, staticRenderFns } from "./TextWithBtnAndColor.vue?vue&type=template&id=375b0e98&scoped=true&"
import script from "./TextWithBtnAndColor.vue?vue&type=script&lang=js&"
export * from "./TextWithBtnAndColor.vue?vue&type=script&lang=js&"
import style0 from "./TextWithBtnAndColor.vue?vue&type=style&index=0&id=375b0e98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b0e98",
  null
  
)

export default component.exports